<app-section-layout [dataForChart]="graphData" [itemTemplate]="horizontalGraph"></app-section-layout>

<ng-template #horizontalGraph let-data="data">
    <app-horizontal-bar-graph 
        [withGestures]="withGestures"
        [graph]="data.graph" 
        [selectedItem]="selectedItem" 
        (onSelectItem)="barClick($event)">
    </app-horizontal-bar-graph>
</ng-template>